import React, { useEffect, useState } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import axios from "axios";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  TablePagination,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
  Grid,
  Typography,
} from "@material-ui/core";

const GenerateReportComp = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dailyData, setDailyData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [activeTab, setActiveTab] = useState(0);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [dailyCount, setDailyCount] = useState(0);

  const getSmsReport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}report`
      );
      const parsedData = JSON.parse(response.data.body);
      setDailyData(parsedData.data || []);
      setDailyCount(parsedData.data.length);
    } catch (error) {
      console.error("Error fetching daily SMS report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSmsReportMonthly = async () => {
    if (!month || !year) {
      alert("Please provide both month and year");
      return;
    }
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}reportMonthly`,
        {
          params: { month, year },
        }
      );
      const parsedData = response.data.body;
      setMonthlyData(parsedData.data || []);
    } catch (error) {
      console.error("Error fetching monthly SMS report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 0) {
      setIsLoading(true);
      getSmsReport();
    }
  }, [activeTab]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPage(0); // Reset pagination when switching tabs
  };

  const generateTotalCost = (data) => {
    const totalSum = data.reduce((sum, row) => {
      const price = parseFloat(row.PriceInUSD);
      return !isNaN(price) ? sum + price : sum; // Only add valid numbers
    }, 0);
    return totalSum;
  };

  const successfulMessages = (data) => {
    console.log("data", data);
    let total = 0;
    data.forEach((ele) => {
      if (
        ele.DeliveryStatus &&
        ele.DeliveryStatus.toLowerCase().includes("accepted")
      ) {
        total += 1;
      }
    });
    console.log("Total Messages Accepted", total);
    return total;
  };

  const renderTable = (data) => (
    <>
      <Box mb={4}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Total Messages Sent:
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {data.length}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Total Cost:
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    $ {generateTotalCost(data).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12} md={6}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Total Successful Messages:
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {successfulMessages(data)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Total Failed Messages:
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    {data.length - successfulMessages(data)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "#f0f0f0" }}>
            <TableRow>
              {/* <TableCell style={{ fontWeight: "bold" }}>Publish Time</TableCell> */}
              <TableCell style={{ fontWeight: "bold" }}>Message ID</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Destination Phone
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Message Type</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Delivery Status
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Price (USD)</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Part Number</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Total Parts</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={index}>
                  {console.log("Lenght is", data.length)}
                  {/* <TableCell>{new Date(row.PublishTimeUTC).toLocaleString()}</TableCell> */}
                  <TableCell>{row.MessageId}</TableCell>
                  <TableCell>{row.DestinationPhoneNumber}</TableCell>
                  <TableCell>{row.MessageType}</TableCell>
                  <TableCell>{row.DeliveryStatus}</TableCell>
                  <TableCell>{row.PriceInUSD}</TableCell>
                  <TableCell>{row.PartNumber}</TableCell>
                  <TableCell>{row.TotalParts}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={data.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="Yesterday" />
        <Tab label="Monthly" />
      </Tabs>

      {isLoading ? (
        <LoadingScreen loading={isLoading} />
      ) : (
        <Box mt={2}>
          {activeTab === 0 ? (
            dailyData.length > 0 ? (
              renderTable(dailyData)
            ) : (
              <p>No daily data available</p>
            )
          ) : (
            <>
              <Grid
                container
                spacing={4}
                alignItems="center"
                justifyContent="center"
                direction={"row"}
              >
                <Grid item xs={12} sm={6} md={1}>
                  <TextField
                    fullWidth
                    label="Month"
                    type="number"
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    InputProps={{ inputProps: { min: 1, max: 12 } }}
                    sx={{ maxWidth: 50 }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <TextField
                    fullWidth
                    label="Year"
                    type="number"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    InputProps={{
                      inputProps: { min: 2000, max: new Date().getFullYear() },
                    }}
                    size="small"
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={fetchSmsReportMonthly}
                  >
                    Fetch Monthly Report
                  </Button>
                </Grid>
              </Grid>
              <Box mt={2}>
                {monthlyData.length > 0 ? (
                  renderTable(monthlyData)
                ) : (
                  <p>No monthly data available</p>
                )}
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default GenerateReportComp;
